import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  toggle(event) {
    event.preventDefault()
    const revealed = this.inputTarget.type === "text"
    this.inputTarget.type = revealed ? "password" : "text"

    if (this.hasShowIconTarget) this.showIconTarget.hidden = !revealed
    if (this.hasHideIconTarget) this.hideIconTarget.hidden = revealed

    const button = event.currentTarget
    button.setAttribute("aria-pressed", String(!revealed))
    button.setAttribute("aria-label", revealed ? "Show SSN" : "Hide SSN")
  }
}
